import React from 'react';
import { Box } from '@mui/material';
import { IAsset, ICategory } from '../../types/damTypes';
import MobileTopBar from '../components/MobileTopBar';
import MobileNavDrawer from '../components/MobileNavDrawer';
import MobileAssetGrid from '../components/MobileAssetGrid';

export default function BrowseScreen(props: {
  categories: ICategory[];
  selectedCategoryIds: string[];
  onCategorySelect: (ids: string[]) => void;
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
  columns: 1 | 2;
  onColumnsChange: (cols: 1 | 2) => void;
  assets: IAsset[];
  loadingAssets: boolean;
  assetError?: string | null;
  onSelectAsset: (assetId: string) => void;
  onAddToCart: (assetId: string) => void;
}) {
  const {
    categories,
    selectedCategoryIds,
    onCategorySelect,
    searchTerm,
    onSearchTermChange,
    columns,
    onColumnsChange,
    assets,
    loadingAssets,
    assetError,
    onSelectAsset,
    onAddToCart,
  } = props;

  const [drawerOpen, setDrawerOpen] = React.useState(false);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <MobileTopBar
        onOpenDrawer={() => setDrawerOpen(true)}
        searchTerm={searchTerm}
        onSearchTermChange={onSearchTermChange}
        columns={columns}
        onColumnsChange={onColumnsChange}
      />

      <MobileNavDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        categories={categories}
        selectedCategoryIds={selectedCategoryIds}
        onCategorySelect={(ids) => {
          onCategorySelect(ids);
          setDrawerOpen(false);
        }}
      />

      <Box sx={{ flex: 1, overflowY: 'auto', bgcolor: '#f5f5f5' }}>
        <MobileAssetGrid
          assets={assets}
          allCategories={categories}
          columns={columns}
          loading={loadingAssets}
          error={assetError}
          onSelectAsset={onSelectAsset}
          onAddToCart={onAddToCart}
        />
      </Box>
    </Box>
  );
}

